import { useQueries, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useHttpClient } from '../../../api/HttpClientContext.js';
import type { GraderCodeBundleAsset } from '../../../services/grader.interface.js';
import { WorkflowApiService } from '../../../services/workflowApi.js';

export function useCodeBundle(workspaceName: string, bundleId: string) {
  const client = useHttpClient();
  const service = useMemo(() => new WorkflowApiService(client), [client]);
  const query = useQuery({
    queryKey: ['code-bundle', workspaceName, bundleId],
    queryFn: () => service.getCodeBundle(workspaceName, bundleId),
    enabled: Boolean(workspaceName && bundleId),
  });
  return {
    data: query.data,
    isLoading: query.isPending,
    error: query.error,
  };
}

export function useCodeBundles(
  workspaceName: string,
  assets: GraderCodeBundleAsset[],
) {
  const client = useHttpClient();
  const service = useMemo(() => new WorkflowApiService(client), [client]);
  return useQueries({
    queries: assets.map(({ bundleId }) => ({
      queryKey: ['code-bundle', workspaceName, bundleId],
      queryFn: () => service.getCodeBundle(workspaceName, bundleId),
      enabled: Boolean(workspaceName && bundleId),
    })),
  });
}
